import React from 'react';
import moment from 'moment';
import {
    makeStyles, withStyles, Container, Grid, Typography,
    responsiveFontSizes, MuiThemeProvider,
    Checkbox, FormControlLabel,
    Button, Paper, Divider, Hidden,
    Menu, MenuItem
} from '@material-ui/core';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import FullCalendar from '@fullcalendar/react'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import interaction from '@fullcalendar/interaction'
import CircularProgress from '@material-ui/core/CircularProgress';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/translucent.css';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ViewLeaveApplication from './component/View'
import Guideline from '../MyCalendar/component/Guideline'
import ExportLeaveSummary from './component/ExportLeaveSummary'
import ExportLeaveDetail from './component/ExportLeaveDetail'
import customAxios from "../../components/API/customAxios";
import {FormattedMessage, useIntl} from 'react-intl';
import {mobileTheme, breakpoints} from "../UIComponent/CommonStyle"
import {isBrowser, isMobile} from "react-device-detect";
import LoadingOverlay from 'react-loading-overlay';
import { compareEvents, formatDateTimeHours } from '../Function/globalFunction';
import ViewCompLeaveReq from './component/ViewCompLeaveReq';
import ExportCompLeaveBalance from './component/ExportCompLeaveBalance';

let color = ''
let background = ''
let className = ''

const thisTheme = responsiveFontSizes(mobileTheme);

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles((theme) => ({
    root: {
        '&:focus': {
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    button: {
        height: '2.8em',
        backgroundColor: '#2C3E50',
        '&:hover': {
            backgroundColor: '#080C0F',
        }
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    mainPaper: {
        padding: theme.spacing(1),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    subPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    generateButton: {
        display: 'flex',
        justifyContent: 'space-between',
        [breakpoints.up("sm")]: {
            justifyContent: 'flex-end',
        }
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    },
    resourceText: {
        fontSize: 11,
        [breakpoints.up("sm")]: {
            fontSize: 12,
        }
    },
    wholeDay: {
        clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0% 100%)'
    },
    am: {
        clipPath: 'polygon(0 0, 100% 0%, 0 100%, 0% 100%)'
    },
    pm: {
        clipPath: 'polygon(100% 0, 100% 0%, 100% 100%, 0% 100%)'
    },
    amToAM: {
        clipPath: 'polygon(0 0, 100% 0, calc(100% - 35px) 100%, 0 100%)'
    },
    amToPM: {
        clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0% 100%);'
    },
    pmToAM: {
        clipPath: 'polygon(35px 0, 100% 0, calc(100% - 35px) 100%, 0 100%)'
    },
    pmToPM: {
        clipPath: 'polygon(35px 0, 100% 0, 100% 100%, 0 100%)'
    },
    accordionSummary: {
        margin: '0 8px'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    compensationLeaveRequest: {
        borderRadius: '50% !important',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '25px',
        width: '25px',
        fontWeight: 'bold',
        marginLeft: 'auto',
        marginRight: 'auto !important',
    },
}));

export default function MyTeam({routing, routingId, source, compLeaveRequest}) {
    const classes = useStyles();
    const intl = useIntl();
    const isShiftDuty = localStorage.getItem('staff_duty') === window.global.shiftDuty;
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [showId, setShowId] = React.useState();
    const [employeeList, setEmployeeList] = React.useState();
    const [isActive, setIsActive] = React.useState(false);
    const [employeeApplication, setEmployeeApplication] = React.useState([]);
    const [unFilterApplication, setUnFilterApplication] = React.useState([]);
    const [popData, setPopData] = React.useState();
    const [showOTRequest, setShowOTRequest] = React.useState(false);
    const [showRejected, setShowRejected] = React.useState(false);
    const [resourceAreaWidth, setResourceAreaWidth] = React.useState('31%');
    const [resourceAreaColumns, setResourceAreaColumns] = React.useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isNewCompLeave, setIsNewCompLeave] = React.useState(false);
    const [isCompLeaveReq, setIsCompLeaveReq] = React.useState(false);

    const calcAreaWidth = () => {
        if (window.orientation === 0) {
            setResourceAreaWidth('60%');
        }

        if (window.orientation === 90) {
            setResourceAreaWidth('35%');
        }
    }

    React.useEffect(() => {
        if (routing !== '') {
            setShowId(routingId)
            setOpen(routing);
        }

        if (compLeaveRequest) {
            setIsCompLeaveReq(true);
        }

        if (source && source === 'newCompLeave') {
            setIsNewCompLeave(true);
        }
    }, [routing, source, compLeaveRequest]);

    let rejectedButtonText;
    if (isBrowser === true) {
        rejectedButtonText = intl.formatMessage({id: 'myteam.show_rejected'})
    } else {
        rejectedButtonText = intl.formatMessage({id: 'myteam.show_rejected_mobile'})
    }

    React.useEffect(() => {
        var template = document.getElementById('template');
        customAxios.get(`/get_team_leaves`)
            .then(res => {
                const employee = res.data['employees'];
                if (employee.length > 0 && employee[0].staff_no == '000001') {
                    employee[0].comp_leave_balance = '-';
                }
                const application = res.data['application'];
                const year = res.data['active_year'];
                let resources = [                    {
                    field: 'title',
                    headerContent: intl.formatMessage({id: 'leave_approval.employee'}),
                    headerClassNames: classes.resourceText,
                    cellClassNames: classes.resourceText
                }];

                for (let i = 2; i >= 0; i--) {
                    resources.push(
                        {
                            field: 'balance_' + i,
                            headerContent: year[i],
                            headerClassNames: classes.resourceText,
                            cellClassNames: classes.resourceText,
                            width: '10%'
                        },
                    )
                }

                // For Comp Leave Balance
                resources.push(
                    {
                        field: 'comp_leave_balance',
                        headerContent: intl.formatMessage({id: 'comp_leave.short_form_comp_leave_balance_hours'}),
                        headerClassNames: classes.resourceText,
                        cellClassNames: classes.resourceText,
                        width: '11.5%'
                    },
                );

                setResourceAreaColumns(resources);
                const application_collection = applicationCollection(application);

                setEmployeeList(employee);
                setEmployeeApplication(application_collection);
                setUnFilterApplication(application_collection);

                setShowCompetent(true);
            })

        // inital calculate calendar width
        calcAreaWidth();

        // check orientation for mobile, calculate width
        window.addEventListener('orientationchange', () => {
            calcAreaWidth();
        });

    }, []);

    React.useEffect(() => {
        if (unFilterApplication) {
            refreshApplicationList();
        }
    }, [showRejected, showOTRequest, unFilterApplication]);

    const [open, setOpen] = React.useState(false);
    const handleOpen = (info) => {
        const startTime = info.event.extendedProps.start_time;
        const patterns = window.global.patterns;
        const isContainsPatterns = patterns.some(term => startTime.includes(term));
        const isNewCompLeave = !isContainsPatterns;
        setIsNewCompLeave(isNewCompLeave);

        const isCompLeaveReq = info.event.extendedProps.action == 'Request';
        setIsCompLeaveReq(isCompLeaveReq)

        setShowId(info.event.id)
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleBack = () => {
        window.location.reload();
    };

    const handleShowOTRequest = (event) => {
        setShowOTRequest(event.target.checked);
    }

    const handleShowRejected = (event) => {
        setShowRejected(event.target.checked);
    }

    const refreshApplicationList = () => {
        let filteredData = [...unFilterApplication];

        if (!showRejected) {
            filteredData = filteredData.filter(element => [3, 6].indexOf(element.status) === -1);
        } 
         
        if (!showOTRequest) {
            filteredData = filteredData.filter(element => (!element.action || element.action != 'Request'));
        }

        setEmployeeApplication(filteredData);
    }

    const eventRender = (info) => {
        if (isBrowser === true) {
            setPopData({
                startDate: info.event.extendedProps.start_date,
                startTime: info.event.extendedProps.start_time,
                mouseOverStartTime: info.event.extendedProps.mouseOverStartTime,
                endDate: info.event.extendedProps.end_date,
                endTime: info.event.extendedProps.end_time,
                mouseOverEndTime: info.event.extendedProps.mouseOverEndTime,
                period: info.event.extendedProps.period,
            })
            tippy(info.el, {
                theme: 'translucent',
                maxWidth: 'none',
                placement: 'bottom',
                content: template.innerHTML,
                allowHTML: true,
            });
        }
    }

    const applicationCollection = (getData) => {
        const data = [];
        for (let i = 0; i < getData.length; i++) {
            for (let j = 0; j < getData[i].length; j++) {
                let isCompLeaveRequest = getData[i][j].type.name === 'Compensation Leave' && ('action' in getData[i][j] && getData[i][j].action === 'Request');
                switch (getData[i][j].type.name) {
                    case 'Annual Leave':
                        color = '#ffa500'
                        background = ""
                        break;
                    case 'Sick Leave':
                        color = '#00b7eb'
                        background = ""
                        className = ""
                        break;
                    case 'Compensation Leave':
                        if (isCompLeaveRequest) {
                            color = '#5A72B7';
                            background = "#5A72B7";
                            className = classes.compensationLeaveRequest;
                        } else {
                            color = '#cccc00';
                            background = "";
                            className = "";
                        }
                        break;
                    case 'Maternity Leave':
                        color = '#b8860b'
                        background = ""
                        className = ""
                        break;
                    case 'Paternity Leave':
                        color = '#0000ff'
                        background = ""
                        className = ""
                        break;
                    case 'Marriage Leave':
                        color = '#800080'
                        background = ""
                        className = ""
                        break;
                    case 'Birthday Leave':
                        color = '#ff00ff'
                        background = ""
                        className = ""
                        break;
                    case 'Compassionate Leave':
                        color = '#ccccff'
                        background = ""
                        className = ""
                        break;
                    case 'Examination Leave':
                        color = '#40e0d0'
                        background = ""
                        className = ""
                        break;
                    case 'Jury Leave':
                        color = '#ff7f50'
                        background = ""
                        className = ""
                        break;
                    case 'No Pay Leave':
                        color = '#808000'
                        background = ""
                        className = ""
                        break;
                    case 'Other Leave':
                        color = '#FAEBD7'
                        background = ""
                        className = ""
                        break;
                }

                switch (String(getData[i][j].status)) {
                    case window.global.pending:
                        background = "repeating-linear-gradient( 45deg, #808080, #808080 4px, " + color + " 4px, " + color + " 10px)"
                        break;
                    case window.global.rejected:
                    case window.global.cancelled:
                        color = '#D3D3D3'
                        background = '#D3D3D3'
                        break;
                    case window.global.submitted:
                        background = "repeating-linear-gradient( 45deg, #808080, #808080 4px, " + color + " 4px, " + color + " 10px)"
                        break;
                    default:
                        background = ""
                        break;
                }

                const fullcalendarStartDate = moment(getData[i][j].start_date).format(window.global.momentFormat),
                    fullcalendarUntilDate = moment(getData[i][j].until_date).format(window.global.momentFormat);

                if (isCompLeaveRequest) {
                    const compLeaveReqDetails = getData[i][j].comp_leave_reqs.details;
                    compLeaveReqDetails.forEach(item => {
                        const itemStartDate = moment(item.from).format(window.global.momentFormat);
                        const itemEndDate = moment(item.to).format(window.global.momentFormat);
                        const record = {
                            id: getData[i][j].id,
                            resourceId: getData[i][j].employee_id,
                            title: 'OT',
                            textColor: '#fff',
                            start_date: fullcalendarStartDate,
                            end_date: fullcalendarUntilDate,
                            start_time: formatDateTimeHours(getData[i][j], 'startTime', intl),
                            mouseOverStartTime: formatDateTimeHours(getData[i][j], 'startTime', intl),
                            end_time: formatDateTimeHours(getData[i][j], 'endTime', intl),
                            mouseOverEndTime: formatDateTimeHours(getData[i][j], 'endTime', intl),
                            period: formatDateTimeHours(getData[i][j], 'period', intl),
                            status: getData[i][j].status,
                            color: color,
                            background: background,
                            action: ('action' in getData[i][j]) ? getData[i][j].action : '',
                            className: className,
                            start: itemStartDate,
                            end: itemEndDate,
                          };
                          data.push(record);
                    });
                } else {
                    // check if start date & end date in same month
                    const isSameMonth = checkIsSameMonth(getData[i][j].start_date, getData[i][j].until_date),
                        isSameYear = checkIsSameYear(getData[i][j].start_date, getData[i][j].until_date);

                    const record = {
                        id: getData[i][j].id,
                        resourceId: getData[i][j].employee_id,
                        start_date: fullcalendarStartDate,
                        end_date: fullcalendarUntilDate,
                        start_time: formatDateTimeHours(getData[i][j], 'startTime', intl),
                        mouseOverStartTime: formatDateTimeHours(getData[i][j], 'startTime', intl),
                        end_time: formatDateTimeHours(getData[i][j], 'endTime', intl),
                        mouseOverEndTime: formatDateTimeHours(getData[i][j], 'endTime', intl),
                        period: formatDateTimeHours(getData[i][j], 'period', intl),
                        status: getData[i][j].status,
                        color: color,
                        background: background,
                        action: ('action' in getData[i][j]) ? getData[i][j].action : '',
                    };

                    if (isSameMonth && isSameYear) {
                        switch (getData[i][j].start_time) {
                            case window.global.am:
                            case window.global.sectionOne:
                                if ([window.global.am, window.global.sectionOne].indexOf(getData[i][j].end_time) !== -1) {
                                    className = classes.amToAM
                                } else {
                                    className = classes.amToPM
                                }
                                break;
                            case window.global.pm:
                            case window.global.sectionTwo:
                                if ([window.global.am, window.global.sectionOne].indexOf(getData[i][j].end_time) !== -1) {
                                    className = classes.pmToAM
                                } else {
                                    className = classes.pmToPM
                                }
                                break;
                        }

                        data.push({
                            ...record,
                            className: className,
                            start: fullcalendarStartDate,
                            end: fullcalendarUntilDate + "T23:59:00",
                        });
                    } else {
                        const startDate = new Date(getData[i][j].start_date),
                            endDate = new Date(getData[i][j].until_date),
                            startMonth = startDate.getMonth(),
                            startYear = startDate.getFullYear(),
                            endMonth = endDate.getMonth(),
                            endYear = endDate.getFullYear(),
                            startMonthLastDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0),
                            endMonthFirstDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);

                        for (let year = startYear; year <= endYear; year++) {

                            let loopStartMonth, loopEndMonth;

                            // if start & end date is same year
                            if (isSameYear) {
                                loopStartMonth = startMonth;
                                loopEndMonth = endMonth;
                            } else {
                                // if year is start year, the end month will be year end
                                if (year === startYear) {
                                    loopStartMonth = startMonth;
                                    loopEndMonth = 11;
                                } // if year is end year, the start month will be year start
                                else if (year === endYear) {
                                    loopStartMonth = 0;
                                    loopEndMonth = endMonth;
                                } else { // if year is other, mean full year
                                    loopStartMonth = 0;
                                    loopEndMonth = 11;
                                }
                            }

                            for (let month = loopStartMonth; month <= loopEndMonth; month++) {
                                let n_fullcalendarStartDate, n_fullcalendarUntilDate;

                                // the month is same as start month
                                if (month === startMonth && year === startYear) {
                                    n_fullcalendarStartDate = moment(getData[i][j].start_date).format(window.global.momentFormat);
                                    n_fullcalendarUntilDate = moment(startMonthLastDate).format(window.global.momentFormat);
                                    className = [window.global.pm, window.global.sectionTwo].indexOf(getData[i][j].start_time) !== -1 ? classes.pmToPM : classes.wholeDay;
                                } else if (month === endMonth && year === endYear) { // the month is same as end month
                                    n_fullcalendarStartDate = moment(endMonthFirstDate).format(window.global.momentFormat);
                                    n_fullcalendarUntilDate = moment(getData[i][j].until_date).format(window.global.momentFormat);
                                    className = [window.global.am, window.global.sectionOne].indexOf(getData[i][j].end_time) !== -1 ? classes.amToAM : classes.wholeDay;
                                } else { // the month is not start/end month mean full month
                                    const recStartDate = new Date(year, month, 1);
                                    const recEndDate = new Date(year, month + 1, 0);
                                    n_fullcalendarStartDate = moment(recStartDate).format(window.global.momentFormat);
                                    n_fullcalendarUntilDate = moment(recEndDate).format(window.global.momentFormat);
                                    className = classes.wholeDay;
                                }

                                data.push({
                                    ...record,
                                    className: className,
                                    start: n_fullcalendarStartDate,
                                    end: n_fullcalendarUntilDate + "T23:59:00",
                                });
                            }
                        }
                    }
                }
            }
        }

        return data;
    }

    const checkIsSameMonth = (start, end) => {
        const startMonth = new Date(start).getMonth() + 1;
        const endMonth = new Date(end).getMonth() + 1;
        return startMonth === endMonth;
    }

    const checkIsSameYear = (start, end) => {
        const startYear = new Date(start).getFullYear();
        const endYear = new Date(end).getFullYear();
        return startYear === endYear;
    }

    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const StyledDivider = withStyles({
        root: {
            background: '#FAC863',
            height: 2,
        },
    })(Divider);

    function compLeaveEvent(info) {
        const startDate = moment(info.event.startStr);
        const endDate = moment(info.event.endStr);
        const endTime = moment(info.event.extendedProps.end_time, 'HH:mm:ss');
        const startTime = moment(info.event.extendedProps.start_time, 'HH:mm:ss');
        const timeDifference = moment.duration(endTime.diff(startTime)).asHours();

        if (info.isStart && info.isEnd) {
            if (startDate.format('YYYY-MM-DD') < endDate.format('YYYY-MM-DD')) {
                if (startTime.isBefore(moment('13:00', 'HH:mm')) && endTime.isBefore(moment('13:00', 'HH:mm'))) {
                    info.el.classList.add(classes.amToAM);
                } else if (startTime.isAfter(moment('13:00', 'HH:mm')) && endTime.isAfter(moment('13:00', 'HH:mm'))) {
                    info.el.classList.add(classes.pmToPM);
                } else if (startTime.isBefore(moment('13:00', 'HH:mm')) && endTime.isAfter(moment('13:00', 'HH:mm'))) {
                    info.el.classList.add(classes.wholeDay);
                } else if (startTime.isAfter(moment('13:00', 'HH:mm')) && endTime.isSameOrBefore(moment('13:00', 'HH:mm'))) {
                    info.el.classList.add(classes.pmToAM);
                } else {
                    info.el.classList.add(className = classes.wholeDay);
                }
            } else {
                if (endTime.isSameOrBefore(moment('13:00:00', 'HH:mm:ss')) && timeDifference < 8) {
                    info.el.classList.add(className = classes.amToAM)
                } else if (startTime.isSameOrAfter(moment('13:00:00', 'HH:mm:ss')) && timeDifference < 8) {
                    info.el.classList.add(className = classes.pmToPM)
                } else if (endTime.isAfter(moment('13:00:00', 'HH:mm:ss')) && timeDifference < 8) {
                    info.el.classList.add(className = classes.pmToPM)
                } else if (startTime.isBefore(moment('13:00:00', 'HH:mm:ss')) && timeDifference < 8) {
                    info.el.classList.add(className = classes.amToAM)
                } else {
                    info.el.classList.add(className = classes.wholeDay);
                }
            }
        }
    }

    function eventDidMount(info) {
        if (info.event.extendedProps.background) {
            info.el.style.background = info.event.extendedProps.background;
        }
        
        if (info.event.extendedProps.action === 'Leave') {
            compLeaveEvent(info);
        }
    }

    return (
        <MuiThemeProvider theme={thisTheme}>
            <main className={classes.content}>
                <div className={classes.appBarSpacer}/>
                <Container maxWidth={false} className={classes.container}>
                    {showCompetent ?
                        <Grid container spacing={2}>
                            <Grid item lg={4} md={2} sm={4} xs={8}>
                                <Typography align="left" style={{fontSize: '1.6em', fontWeight: 600}}>
                                    <FormattedMessage
                                        id="navigation.myteam"
                                    />
                                </Typography>
                            </Grid>
                            <Grid item lg={8} md={10} xs={12}>
                                <div className={classes.generateButton}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={showOTRequest}
                                                onChange={handleShowOTRequest}
                                                name="showOTRequest"
                                                color="primary"
                                            />
                                        }
                                        label={intl.formatMessage({id: 'myteam.ot_request'})}
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={showRejected}
                                                onChange={handleShowRejected}
                                                name="checkedB"
                                                color="primary"
                                            />
                                        }
                                        label={rejectedButtonText}
                                    />
                                    <Hidden smDown>
                                        <Button
                                            aria-controls="customized-menu"
                                            aria-haspopup="true"
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            onClick={handleOpenMenu}
                                            startIcon={<InsertDriveFileIcon/>}
                                        >
                                            {intl.formatMessage({id: 'myteam.export'})}
                                        </Button>
                                        <StyledMenu
                                            id="customized-menu"
                                            anchorEl={anchorEl}
                                            keepMounted
                                            open={Boolean(anchorEl)}
                                            onClose={handleCloseMenu}
                                        >
                                            <LoadingOverlay
                                                active={isActive}
                                                styles={{
                                                    overlay: base => ({
                                                        ...base,
                                                        background: '#D0D0D0',
                                                        opacity: 0.7,
                                                    }),
                                                }}
                                                spinner
                                            >
                                                <StyledMenuItem>
                                                    <ListItemIcon>
                                                        <ExportLeaveSummary setIsActive={setIsActive} isShiftDuty={isShiftDuty}/>
                                                    </ListItemIcon>
                                                </StyledMenuItem>
                                                <StyledMenuItem>
                                                    <ListItemIcon>
                                                        <ExportLeaveDetail setIsActive={setIsActive}/>
                                                    </ListItemIcon>
                                                </StyledMenuItem>
                                                <StyledMenuItem>
                                                    <ListItemIcon>
                                                        <ExportCompLeaveBalance setIsActive={setIsActive}/>
                                                    </ListItemIcon>
                                                </StyledMenuItem>
                                            </LoadingOverlay>
                                        </StyledMenu>
                                    </Hidden>
                                </div>
                            </Grid>
                            <Hidden smDown>
                                <Grid item xs={12}>

                                    <Paper className={classes.mainPaper}>
                                        <Guideline page={'My Team'}/>
                                    </Paper>

                                </Grid>
                            </Hidden>
                            <Hidden mdUp>
                                <Accordion className={classes.accordionSummary}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography
                                            className={classes.heading}>{intl.formatMessage({id: 'guideline'})}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Guideline page={isMobile ? 'My Team' : 'Calendar'}/>
                                    </AccordionDetails>
                                </Accordion>
                            </Hidden>
                            <Grid item xs={12}>
                                <StyledDivider/>
                                <Paper className={classes.subPaper}>
                                    <FullCalendar
                                        timeZone='Asia/Hong_Kong'
                                        plugins={[
                                            resourceTimelinePlugin,
                                            interaction,
                                        ]}
                                        headerToolbar={{
                                            left: '',
                                            center: 'title',
                                            right: 'prev,next'
                                        }}
                                        titleFormat={{year: 'numeric', month: 'long'}}
                                        initialView='resourceTimelineMonth'
                                        slotLabelFormat={[
                                            {weekday: 'short'},
                                            {day: 'numeric'}]}
                                        eventMouseEnter={eventRender}
                                        schedulerLicenseKey={process.env.REACT_APP_FULLCALENDAR_LICENSEKEY}
                                        resourceOrder={'title'}
                                        resourceAreaColumns={resourceAreaColumns}
                                        eventDidMount={eventDidMount}
                                        resourcesInitiallyExpanded={false}
                                        resources={employeeList}
                                        events={employeeApplication}
                                        height={600}
                                        eventClick={handleOpen}
                                        resourceAreaWidth={resourceAreaWidth}
                                        displayEventEnd={false}
                                        displayEventTime={false}
                                        contentHeight={300}
                                        handleWindowResize={true}
                                        eventOrder={compareEvents}
                                    />
                                </Paper>
                            </Grid>
                        </Grid>
                        :
                        <div className={classes.circularProgress}>
                            <CircularProgress/>
                        </div>
                    }
                </Container>
                {open && 
                    (isCompLeaveReq ? (
                        <ViewCompLeaveReq
                            handleClose={handleClose}
                            open={open}
                            showId={showId}
                            backToTable={handleBack}
                            isNewCompLeave={isNewCompLeave}
                        />
                    ) : (
                        <ViewLeaveApplication 
                            handleClose={handleClose} 
                            open={open} 
                            showId={showId} 
                            backToTable={handleBack} 
                            isNewCompLeave={isNewCompLeave}
                        />
                    ))}
                {
                    popData &&
                    <div id="template" style={{display: 'none'}}>
                        <Typography>{intl.formatMessage({id: 'common.from'})}:&nbsp;{popData.startDate}&nbsp;{popData.mouseOverStartTime}</Typography>
                        <Typography>{intl.formatMessage({id: 'common.to'})}:&nbsp;{popData.endDate}&nbsp;{popData.mouseOverEndTime}</Typography>
                        <Typography>{intl.formatMessage({id: 'new_application.taken'})}:&nbsp;{popData.period}</Typography>
                    </div>
                }
            </main>
        </MuiThemeProvider>
    );
}
